import React, { useEffect, useState } from 'react';
import { Helmet } from 'react-helmet-async';
// @mui
import { useTheme, styled } from '@mui/material/styles';
import { Grid, Container, Typography, Tabs, Tab } from '@mui/material';
// components

import LocationCityIcon from '@mui/icons-material/LocationCity';
import StoreMallDirectoryIcon from '@mui/icons-material/StoreMallDirectory';
import { HomeFilled, UserOutlined } from '@ant-design/icons';
import { useNavigate } from 'react-router-dom';

// sections
// import { AppCurrentVisits, AppWebsiteVisits } from '../../sections/@dashboard/app';
// import UserPage from '../UserPage';
// import zodiacApiFunctions from '../../API/zodiacApi';

// import LocationPage from '../LocationPage';
import { Height } from '@mui/icons-material';
import apiFunctions from '../API/api';
import { AppWidgetSummary, AppCurrentVisits, AppWebsiteVisits } from '../sections/@dashboard/app';
import zodiacApiFunctions from '../API/zodiacApi';

import { useFilter } from '../layouts/dashboard/FilterProvider';
// import DownloadReport from '../DownloadReport';
// import Genral from './Genral';
// import DownloadZodiacReport from './DownloadZodiacReport';
import LuckyMeterReport from './LuckyMeterReport';
import Genral from './Zodiac/Genral';
import BaseColor from '../BaseColor';

// ----------------------------------------------------------------------
// Styled components should be defined after all regular imports
const StyledTabs = styled(Tabs)(({ theme }) => ({
  overflow: 'hidden',
  '& .MuiTabs-flexContainer': {
    width: '100%',
    justifyContent: 'space-evenly',
    backgroundColor: 'pink',
    borderRadius: '1rem',
    flexWrap: 'wrap', // Set flex-wrap to 'wrap' for larger screens
    overflowX: 'auto',
    scrollbarWidth: 'none',
    '-ms-overflow-style': 'none',
    '&::-webkit-scrollbar': {
      display: 'none',
    },
    [theme.breakpoints.down('sm')]: {
      flexWrap: 'nowrap', // Set flex-wrap to 'nowrap' for smaller screens
      maxWidth: '100%', // Add this to limit the maximum width
    },
    [theme.breakpoints.down('xs')]: {
      flexWrap: 'nowrap', // Set flex-wrap to 'nowrap' for smaller screens
      maxWidth: '80%', // Add this to limit the maximum width
    },
  },
  '& .Mui-selected': {
    borderBottom: `2px solid ${BaseColor}`, // Change the color and width of the active indicator here
    minWidth: '50px', // Set the width of the active indicator to match tab minWidth
  },
}));

const StyledTab = styled(Tab)(({ theme }) => ({
  flex: '0 0 auto',
  // minWidth: '50px', // Default width for larger screens and active indicator
  color: '#cd4269',
  fontSize: '1rem',
  '&.Mui-selected': {
    color: '#cd4269',
  },
  '&:hover': {
    color: '#cd4269',
  },

  // Responsive tab sizing
  [theme.breakpoints.down('sm')]: {
    // minWidth: '150px', // Adjust tab width for small screens (e.g., tablets)
    fontSize: '0.9rem', // Adjust font size for small screens
    padding: '0',
    margin: '0',
    width: '33%',
  },
  [theme.breakpoints.down('xs')]: {
    minWidth: '20px', // Further reduce tab width for phones
    fontSize: '0.8rem', // Further reduce font size for phones
    width: 'max-content',
    padding: '0',
    margin: '0',
  },
}));
export default function LuckyDraw() {
  const { filter } = useFilter();
  const theme = useTheme();
  const [value, setValue] = useState(0);
  const [count, setCount] = useState([]);
  const [date, setDate] = useState([]);
  const [totalUsers, setTotalUsers] = useState(0);
  const [totalVisits, setTotalVisits] = useState(0);
  const [couplesCount, setCouplesCount] = useState(0);

  const [visitDates, setVisitDate] = useState([]);

  const [visitCounts, setVisitCount] = useState([]);
  const [userData, setUserData] = useState();
  const[totalExistingUser,setTotalExistingUser]=useState(0);

  const currentYear = new Date().getFullYear();
  const nav = useNavigate();
  useEffect(() => {
    const token = localStorage.getItem('token');
    if (token === '' || token === 'undefined' || token === undefined || token === null) {
      nav('/login');
    }
  }, []);
  useEffect(() => {
    async function getUsers() {
      function formatDate(dateString) {
        const options = { month: 'numeric', day: '2-digit', year: 'numeric' };
        const date = new Date(dateString);
        return date.toLocaleDateString(undefined, options);
      }
      try {
        const data = await apiFunctions.getUserData(filter);
        setTotalUsers(data.totalUserCountBetweenDates);
        // const countMarital = data.userData.filter((user) => user.Marital === 1).length;
        // setCouplesCount(countMarital);
        setUserData(data.userData);
        console.log(data.userData);
        // setUsedGV(data.used);
        const dates = data.dateWiseUserCounts.map((entry) => entry.date);
        const counts = data.dateWiseUserCounts.map((entry) => entry.count);

        const formattedDates = dates.map((date) => new Date(date));

        // Format each date string in the array
        const FinalDate = formattedDates.map(formatDate);
        FinalDate.sort((a, b) => {
          const dateA = new Date(a);
          const dateB = new Date(b);
          return dateA - dateB;
        });
        setCount(counts);
        setDate(FinalDate);
      } catch (error) {
        console.error('Error fetching user counts:', error);
        // Handle error if needed
      }
    }

    async function getVisits() {
      function formatDate(dateString) {
        const options = { month: 'numeric', day: '2-digit', year: 'numeric' };
        const date = new Date(dateString);
        return date.toLocaleDateString(undefined, options);
      }
      try {
        const data = await apiFunctions.getVisitData(filter);
        setTotalVisits(data.totalCountBetweenDates);
        const dates = data.dateWiseCounts.map((entry) => entry.date);
        const counts = data.dateWiseCounts.map((entry) => entry.count);

        const formattedDates = dates.map((date) => new Date(date));

        // Format each date string in the array
        const FinalDate = formattedDates.map(formatDate);
        FinalDate.sort((a, b) => {
          const dateA = new Date(a);
          const dateB = new Date(b);
          return dateA - dateB;
        });
        setVisitCount(counts);
        setVisitDate(FinalDate);
      } catch (error) {
        console.error('Error fetching user counts:', error);
        // Handle error if needed
      }
    }
    async function getExisits() {
      function formatDate(dateString) {
        const options = { month: 'numeric', day: '2-digit', year: 'numeric' };
        const date = new Date(dateString);
        return date.toLocaleDateString(undefined, options);
      }
      try {
        const data = await apiFunctions.getExisitingUser(filter);
        console.log("dddd",data);
       setTotalExistingUser(data.count)
      } catch (error) {
        console.error('Error fetching user counts:', error);
        // Handle error if needed
      }
    }
    getExisits();
    getUsers();
    getVisits();
  }, [filter]);
  const handleChange = (event, newValue) => {
    setValue(newValue);
  };

  return (
    <>
      <Helmet>
        <title> MIA </title>
      </Helmet>

      <Container maxWidth="xl">
        <div
          style={{
            display: 'flex',
            justifyContent: 'space-between',
          }}
        >
          <Typography variant="h4" sx={{ mb: 5, color: '#D24A61' }}>
            Hi, Welcome back
          </Typography>
          {/* <DownloadZodiacReport /> */}
          <LuckyMeterReport />
        </div>

        <StyledTabs value={value} onChange={handleChange} aria-label="icon position tabs example" indicatorColor="red">
          <StyledTab
            icon={<HomeFilled style={{ marginLeft: '5px' }} />}
            label="General"
            iconPosition="start"
            sx={{
              color: '#cd4269',
              fontSize: '1rem',
            }}
          />
          <StyledTab
            icon={<LocationCityIcon style={{ marginLeft: '5px' }} />}
            iconPosition="end"
            label="Visits"
            sx={{
              color: '#cd4269',
              fontSize: '1rem',
            }}
          />
        </StyledTabs>
        <br />
        <Grid container spacing={3}>
          <Grid item xs={12} md={6} lg={8}>
            {value === 0 && (
              <AppWebsiteVisits
                title="User Counts"
                subheader="User counts per day"
                chartLabels={date}
                chartData={[
                  {
                    name: 'Users',
                    type: 'area',
                    fill: 'gradient',
                    data: count,
                  },
                ]}
              />
            )}

            {value === 1 && (
              <AppWebsiteVisits
                title="User Visits"
                subheader="User visits per day"
                chartLabels={visitDates}
                chartData={[
                  {
                    name: 'Users',
                    type: 'area',
                    fill: 'gradient',
                    data: visitCounts,
                  },
                ]}
              />
            )}
          </Grid>
          <Grid item xs={12} md={6} lg={4} marginBottom={0}>
            {value === 1 && (
              <Grid item xs={12}>
                <AppWidgetSummary
                  title="Total Visits"
                  total={totalVisits}
                  color="secondary"
                  sx={{ backgroundColor: BaseColor, color: 'white' }}
                  icon={'ant-design:shopping-filled'}
                />
              </Grid>
            )}

            {value === 0 && (
              <Grid item xs={12}>
                <AppWidgetSummary
                  title="Registered Users"
                  total={totalUsers}
                  color="secondary"
                  sx={{ backgroundColor: BaseColor, color: 'white', height: '100%' }}
                  icon={'ant-design:shopping-filled'}
                />
              </Grid>
            )}

             {value === 0 && (
              <Grid item xs={12}>
                <AppWidgetSummary
                  title="Exisiting Users"
                  total={totalExistingUser}
                  color="secondary"
                  sx={{ backgroundColor: 'white', color: `${BaseColor}`, boxShadow: '1px 1px 5px #ffeff1' }}
                  icon={'ant-design:carry-out-filled'}
                />
              </Grid>
            )}
            {/* {value === 0 && (
              <Grid
                item
                xs={12}
                sx={{
                  marginTop: '1rem',
                }}
              >
                <AppWidgetSummary
                  title="Couples"
                  total={couplesCount}
                  color="secondary"
                  sx={{ backgroundColor: 'white', color: `${BaseColor}`, boxShadow: '1px 1px 5px #ffeff1' }}
                  icon={'ant-design:carry-out-filled'}
                />
              </Grid>
            )} */}
          </Grid>
          <Grid item xs={12} md={12} lg={12}>
            {userData && value === 0 && <Genral data={userData} />}
          </Grid>
        </Grid>
      </Container>
    </>
  );
}
